import "./TabNavbar.css";

const Navbar = (props) => {
	const lastTab = props.tab.length - 1;
	return (
		<ul className="nav nav-tabs justify-content-center" id="myTab">
			{props.tab.map((tab, key) => (
				<li className="nav-item" key={key}>
					<a
						href={`#${tab.tabLink}`}
						className={`nav-link nav-link-${props.color} ${key === 0 ? "active border-left" : ""} ${
							key === lastTab ? "border-right" : ""
						}`}
						data-bs-toggle="tab"
					>
						{tab.title}
					</a>
				</li>
			))}
		</ul>
	);
};

export default Navbar;
